// extracted by mini-css-extract-plugin
module.exports = {"root":"NotificationFooter_root__87jr7","details":"NotificationFooter_details__IXA8O","actionLink":"NotificationFooter_actionLink__sHmgl"};